import {
  CheckList,
  FileUpload,
  RadioList,
  TextArea,
  TextInput,
} from "@milestone/component-library";
import { Section } from "../formComponents.styles";
import { Question } from "./checkIn.types";
import * as Yup from "yup";
import styled from "styled-components";
import { DateSelectWrapper, DropDownWrapper } from "../formComponents";

export const oneToThree = ["1", "2", "3"] as const;

export const CheckInSection = styled(Section)`
  gap: 40px;
`;

export const buildQuestionComponent = (question: Question) => {
  let component = <div />;
  switch (question.type) {
    case "TextInput":
      component = (
        <TextInput
          label={question.label}
          name={question.name}
          placeholder={question.placeholder}
        />
      );
      break;
    case "TextArea":
      component = (
        <TextArea
          label={question.label}
          name={question.name}
          placeholder={question.placeholder}
        />
      );
      break;
    case "DatePicker":
      component = (
        <DateSelectWrapper label={question.label} name={question.name} />
      );
      break;
    case "FileUpload":
      component = <FileUpload label={question.label} name={question.name} />;
      break;
    case "RadioList":
      if (question.options) {
        component = (
          <RadioList
            label={question.label}
            name={question.name}
            options={question.options}
          />
        );
      } else {
        console.error(question.name, "RadioList needs options");
      }
      break;
    case "CheckList":
      if (question.options) {
        component = (
          <CheckList
            label={question.label}
            name={question.name}
            options={question.options}
          />
        );
      } else {
        console.error(question.name, "CheckList needs options");
      }
      break;
    case "DropDown":
      if (question.options) {
        component = (
          <DropDownWrapper
            label={question.label}
            name={question.name}
            data={question.options}
          />
        );
      } else {
        console.error(question.name, "DropDown needs options");
      }
      break;
    default:
      console.error("Bad Question Type", question.type, question.name);
  }
  return (
    <Section key={question.name}>
      {component}
      {question.hasComments && (
        <TextArea
          label="Comments"
          name={question.name + "Comments"}
          placeholder="Comments"
        />
      )}
    </Section>
  );
};

export const getYupObject = (
  question: Question | { type: string; options?: Array<any>; name: string }
) => {
  Yup.string().required("Required");
  switch (question.type) {
    case "FileUpload":
    case "TextInput":
    case "TextArea":
      return Yup.string().required("Required");
    case "DatePicker":
      return Yup.date().required("Required").min(new Date(1900, 0, 1));
    case "CheckList":
      if (question.options)
        return Yup.array()
          .of(Yup.mixed().oneOf([...question.options]))
          .required("Required");
      break;
    case "RadioList":
    case "DropDown":
      if (question.options)
        return Yup.mixed()
          .oneOf([...question.options])
          .required("Required");
      break;
    default:
      console.error("Bad Question Type", question.type, question.name);
  }
};

export const extractQuestions = (questions: Array<Question>) => {
  const values: Record<string, any> = {};
  const schema: Record<string, any> = {};
  const components: Array<JSX.Element> = [];
  for (const question of questions) {
    values[question.name] = question.value;
    schema[question.name] = getYupObject(question);
    components.push(buildQuestionComponent(question));
    if (question.hasComments) {
      const name = question.name + "Comments";
      values[question.name + "Comments"] = question.comments;
      schema[question.name + "Comments"] = getYupObject({
        type: "TextArea",
        name,
      });
    }
  }
  const Schema = Yup.object(schema);
  return { values, Schema, components };
};
